import { FinancialInstitution } from '@/types/general';

export type LoanType = string;

export interface AllLoans {
  loans: Loan[];
}
export interface Loan {
  financialInstitution: FinancialInstitution;
  name: string;
  imageSlug: string;
  loanType: LoanType;
  creditLimit: number;
  id: string;
  slug: string;
  countryCode: string;
  requiresCleanName: boolean;
  redirectURL: string;
  interestRate: string;
  paymentDeadline: string;
  pros: string[];
  cons: string[];
  currencySymbol: string;
}

export interface LoanParams {
  loanType?: LoanType;
  creditLimitFloor?: number;
  name?: string;
  country?: string;
  page?: number;
  size?: number;
  bank?: string[] | string;
}

export interface LoanRequest {
  response: LoanParams;
}

export interface LoanResponse {
  loans: Loan[];
  total: number;
  totalPages: number;
}

export enum LoanTypeLabel {
  Guarantee = 'Com garantia',
  Personal = 'Pessoal',
  Consignment = 'Consignado',
  Microentrepreneurs = 'Para microempreendedores',
}
